module.exports = __webpack_public_path__ + "static/media/quickbooks-icon-sm.8ce591d2.jpeg";